<template>
  <h-msg-box
    v-model="showModal"
    width="480"
    @on-close="handleMsgBoxClose"
    class="financial-competition-modal"
    :mask-closable="false"
  >
    <p slot="header">
      <span class="model-header">创建队伍</span>
    </p>
    <div>
      <h-form
        ref="createTeamForm"
        :model="createTeamParams"
        :rules="createRuleValidate"
        label-position="right"
        :label-width="110"
      >
        <h-form-item label="队伍名称" prop="team_name">
          <h-input
            v-model="createTeamParams.team_name"
            placeholder="名称最多10位，避免敏感词汇"
            :maxlength="10"
          ></h-input>
        </h-form-item>
        <h-form-item label="队长姓名" prop="emp_name">
          <h-input
            v-model="createTeamParams.emp_name"
            placeholder="请输入真实姓名"
            :maxlength="8"
          ></h-input>
        </h-form-item>
        <h-form-item label="工作单位" prop="subordinate_company">
          <h-select v-model="createTeamParams.subordinate_company">
            <h-option
              :value="list.name"
              v-for="list in companyList"
              :key="list.name"
              :label="list.name"
            >
              {{ list.name }}
            </h-option>
          </h-select>
        </h-form-item>
        <h-form-item label="所在子公司/部门" prop="emp_post">
          <h-input
            v-model="createTeamParams.emp_post"
            placeholder="请输入子公司/部门"
            :maxlength="20"
          ></h-input>
        </h-form-item>
      </h-form>
    </div>
    <div slot="footer">
      <comp-button class="btn-icon" @click="confirmCreateTeam"
        >创建队伍</comp-button
      >
    </div>
  </h-msg-box>
</template>

<script>
import { CompButton } from '../common'
import Api from '@/api/competition/financialIndex'
import { mapGetters } from 'vuex'
export default {
  name: 'CreateTeam',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (value === '') return
      if (/^[\u4E00-\u9FA5]+$/.test(value)) {
        callback()
      } else {
        callback(new Error('姓名只支持中文'))
      }
    }
    return {
      showModal: false,
      createTeamParams: {
        team_name: '',
        emp_name: '',
        subordinate_company: '',
        emp_post: ''
      },
      createRuleValidate: {
        team_name: [
          { required: true, message: '队伍名称不能为空', trigger: 'blur' }
        ],
        emp_name: [
          { required: true, message: '队长姓名不能为空', trigger: 'blur' },
          { validator: validateName, trigger: 'blur' }
        ],
        subordinate_company: [
          { required: true, message: '工作单位不能为空', trigger: 'blur' }
        ],
        emp_post: [{ required: true, message: '所在子公司/部门不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['competeUser', 'companyList'])
  },
  components: {
    CompButton
  },
  created() {
    this.showModal = this.value
  },
  methods: {
    resetForm() {
      this.createTeamParams = {
        team_name: '',
        emp_name: '',
        subordinate_company: '',
        emp_post: ''
      }
      this.$refs['createTeamForm'].resetFields()
    },
    handleMsgBoxClose() {
      this.$emit('stateChange', '')
    },
    confirmCreateTeam() {
      this.$refs['createTeamForm'].validate((valid) => {
        if (valid) {
          Api.postCompetTeam(this.createTeamParams).then((res) => {
            if (res.error_code === '0') {
              this.$emit('stateChange', 'createTeamSuccess')
            } else {
              this.$hMessage.info(res.error_info)
            }
          })
        }
      })
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.showModal = newValue
      !this.showModal && this.resetForm()
    },
    showModal(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.model-header {
  font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
</style>







// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/TeamUp/CreateTeam.vue